<template>
    <button @click.prevent="addToCart" class="button buy add-to-cart-btn"
            :class="dynamicClass"
            :title=" product.order_price > 0 ? buttonCaption : 'Ціну уточнюйте'">
        <template v-if="!mobile">
            {{ product.order_price > 0 ? buttonCaption : 'Ціну уточнюйте' }}
        </template>
        <template v-if="mobile">
            <span class="ic icon-shopping-cart-1"></span>
            <span v-if="!productInCart" class="plus">+</span>
        </template>
    </button>
</template>



<script>
export default {
    props: {
        product: Object,
        aid: Object,
        remnant: Object,
        mobile: Boolean,
        title: {
            type: String,
            default: 'В кошик'
        },
    },
    computed: {
        productInCart() {
            return this.$store.getters['cart/getItemInCartById'](this.product.id)
        },
        buttonCaption() {
            return this.productInCart?.totalQuantity && !this.mobile > 0 ? 'У кошику' : this.title
        },
        dynamicClass() {
            if (this.mobile) {
                return this.productInCart?.totalQuantity > 0  ? { 'in-cart-green': true} : ''
            }
            return this.productInCart?.totalQuantity > 0  ? { 'button-2': true,'one-click': true } : ''
        }
    },
    methods: {
        addToCart() {
            if (this.product.order_price > 0) {
                if (this.product) {
                    this.$store.dispatch('cart/add', { product_id: this.product.id || this.product,
                        qty: {
                            totalQuantity: 1,
                            fullQuantity: 1,
                            partQuantity: 0,
                            packQuantity: 0,
                            pack: null,
                            minPack: null,
                        },
                    })
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({ ecommerce: null })
                    window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                            currency: "UAH",
                            value: this.product.price,
                            items: [
                                {
                                    item_id: this.product.id,
                                    item_name: this.product.name,
                                    price: this.product.price,
                                    quantity: 1
                                }
                            ]
                        }
                    })
                }
                if (this.aid) {
                    for (let item of this.aid.items) {
                        this.$store.dispatch('cart/add', { product_id: item.product_id })
                    }
                }
                if (this.remnant) {
                    this.$store.dispatch('cart/add', { remnant: this.remnant })
                }
            } else {
                this.$inertia.modal(this.route('frontend.check-price.index', { product_id: this.product.id }))
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.in-cart-green {
  background: #23a833 !important;
}
.button-2:hover {
  background: #fff !important;
  color: #000;
}
</style>
